import { useEffect } from 'react';
import LogRocket from 'logrocket';

const logRocketFreightGridVisitEventName = 'VISIT_FREIGHT_GRID';

let hasTrackedVisit = false;

export const useTrackFreightGridVisit = (): void => {
  useEffect(() => {
    if (hasTrackedVisit) {
      return;
    }
    hasTrackedVisit = true;

    const environment = process.env.NODE_ENV || 'development';
    LogRocket.track(logRocketFreightGridVisitEventName, {
      env: environment,
    });
  }, []);
};
